import styled from "../../../styled/index";
import { RestaurantUtils } from "@lib/common";
export const OrderStatusBackground = styled("div") `
  background: ${({ status }) => RestaurantUtils.order.color(status)};
  color: white;
`;
export const OrderStatusText = styled("div") `
  color: ${({ status }) => RestaurantUtils.order.color(status)};
`;
//# sourceMappingURL=index.js.map